export default __webpack_public_path__ + "static/media/rabbit-black.63537b81.png";